import { lazy } from 'react';
import Loadable from 'components/Loadable';
import ViewCompany from 'pages/settingss/company/ViewCompany';
import ComplaintType from 'pages/complainttype/ComplaintType';
import Admin from 'pages/settingss/admin/Admin';
import AdminView from 'components/admin/AdminView';
import RolesAndPermission from 'pages/settingss/rolesandpermissions/RolesAndPermissions';
import routeAccess from 'hasAccess/routeAccess';
import { getRolePermission } from 'services/modules/getRolePermission';
import EditProfile from 'layout/Dashboard/Header/HeaderContent/Profile/EditProfile';
import Instructor from 'pages/instructor/Instructor';
import StudentTable from 'pages/instructor/StudentTable';
import Student from 'pages/student/Student';
import StudentsList from 'pages/admin/StudentsList';
import CreatePoseInstructor from 'components/instructor/CreatePoseInstructor';
import PoseTracking from 'components/student/PoseTracking';
import CreatePosePage from 'components/instructor/CreatePosePage';
import ViewPosePage from 'components/instructor/ViewPosePage';
import PoseCategory from 'pages/student/PoseCategory';
import StudentDetails from 'pages/admin/StudentDetails';
import ViewStudentPoseData from 'components/student/ViewStudentPoseData';
import CoachesList from 'pages/admin/CoachesList';
import UsersList from 'pages/admin/users/UsersList';
import CoachDetails from 'pages/admin/CoachDetails';
import CustomPosesTable from 'pages/admin/contentoversight/custom-poses/CustomPosesTable';
import StudentProfile from 'pages/instructor/StudentProfile';
import Support from 'pages/support/Support';
import Report from 'pages/reports&analyts/Report';
import Subscription from 'pages/subscription/Subscription';
import AssignedStudents from 'pages/instructor/AssignedStudents';
import SystemMonitoring from 'pages/system-monitoring/SystemMonitoring';
import SessionSummary from 'pages/student/SessionSummary';
import BreakDown from 'pages/student/BreakDown';
import CoachProgressTracker from 'components/reports/ProgressTracker';
import ProgressTracker from 'pages/student/ProgressTracker';
import StudentSupport from 'pages/student/Support';
import Enrollment from 'components/subscription/Enrollment';
import PaymentLogs from 'components/subscription/PaymentLogs';
import Coupons from 'components/subscription/CouponsList';
import ViewProfile from 'layout/Dashboard/Header/HeaderContent/Profile/ViewProfile';
import Library from 'components/library/Library';
import FeatureAnnouncement from 'pages/admin/FeatureAnnouncement';
import StudentReports from 'components/reports/StudentReports';
import SessionAnalytics from 'components/reports/SessionAnalytics';
import StandalonePractice from 'components/StandalonePractice';
import ContinuousFlow from 'components/ContinuousFlow';
import Summary from 'components/Summary';
import AsanaSession from 'components/student/AsanaSession';
import PranayamaSession from '../pages/pranayamma/PranayamaSession';
import RelaxationTracking from '../pages/relaxation/RelaxationTracking';   // adjust path
// or wherever it actually lives

// Manager Pages
const ManagerCourses = Loadable(lazy(() => import('pages/manager/ManagerCourses')));
const StaffManagement = Loadable(lazy(() => import('pages/manager/staffManagement/StaffList')));
const ManagerStudentReports = Loadable(lazy(() => import('pages/manager/ManagerStudentReports')));
const ManagerSessionReports = Loadable(lazy(() => import('pages/manager/ManagerSessionReports')));
const ManagerSupport = Loadable(lazy(() => import('pages/manager/ManagerSupport')));

// Staff Pages
const StaffDashboard = Loadable(lazy(() => import('pages/staff/StaffDashboard')));
const StaffMyClasses = Loadable(lazy(() => import('pages/staff/StaffMyClasses')));
const StaffStudents = Loadable(lazy(() => import('pages/staff/StaffStudents')));
const StaffProgressTracker = Loadable(lazy(() => import('pages/staff/StaffProgressTracker')));
const StaffSupport = Loadable(lazy(() => import('pages/staff/StaffSupport')));
const StaffSummary = Loadable(lazy(() => import('pages/staff/StaffSummary')));

// project import
const DashboardLayout = Loadable(lazy(() => import('layout/Dashboard')));
const PagesLayout = Loadable(lazy(() => import('layout/Pages')));
const SimpleLayout = Loadable(lazy(() => import('layout/Simple')));
const SimpleLayoutType = Loadable(lazy(() => import('config')));

const Dashboard = Loadable(lazy(() => import('pages/dashboard/Dashboard')));
const Company = Loadable(lazy(() => import('pages/settingss/company/Company')));

const DocumentTab = Loadable(lazy(() => import('pages/settingss/document/DocumentTab')));

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

const ReportTab = Loadable(lazy(() => import('pages/features/reports/ReportTab')));

const AppContactUS = Loadable(lazy(() => import('pages/contact-us')));
// render - sample page
// const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));

// ==============================|| MAIN ROUTING ||============================== //

const roleId = localStorage.getItem('roleid');

// Fetch role permissions
// const data = await getRolePermission({
//   roleid: roleId
// });

// console.log('Main Routes:', data);

// const rolePermissions = data?.[0]?.webpermissions || [];

// console.log(rolePermissions, 'rolePermissions');??

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'instructor',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <Instructor />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
        {
          path: 'library',
          element: <Library />
        },
        {
          path: 'students-table',
          element: <StudentTable />
        },
        {
          path: 'Students-Reports',
          element: <StudentReports />
        },
        {
          path: 'Coach-Progress-Tracker',
          element: <CoachProgressTracker />
        },
        {
          path: 'Session-Analytics',
          element: <SessionAnalytics />
        },
        {
          path: 'subscription',
          element: <Subscription />
        },
        {
          path: 'support',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <Support />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },

        {
          path: 'quick-actions/students-table',
          element: <StudentTable />
        },
        {
          path: 'quick-actions/library',
          element: <Library />
        },
        {
          path: 'quick-actions/Students-Reports',
          element: <StudentReports />
        },
        {
          path: 'create-pose',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <CreatePoseInstructor />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
        {
          path: 'assigned-students/:courseId',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <AssignedStudents />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
        {
          path: 'create-pose-page',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <CreatePosePage />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
        {
          path: 'view-asana/:courseid',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <ViewPosePage />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
        {
          path: 'pose-tracking',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            // <PoseTracking />
            <AsanaSession />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
         {
          path: 'pranayama-tracking',
          element: (
            // routeAccess({
            //   moduleid: 10,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <PranayamaSession />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
        {
      path: 'relaxation-tracking',
      element: <RelaxationTracking />
    },
        {
          path: 'asanas/:courseid/continuous',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <ContinuousFlow />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
        {
          path: 'asanas/:courseid/standalone',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <StandalonePractice />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
        {
          path: 'asanas/:courseId/summary',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <Summary />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },

        {
          path: '/asanas/:courseid',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <PoseCategory />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },

        {
          path: 'students-List',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <StudentsList />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },

        {
          path: 'coaches-List',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <CoachesList />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
        {
          path: 'users-List',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <UsersList />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },

        {
          path: 'students-List/student-details',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <StudentDetails />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
        {
          path: 'students-List/student-profile',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <StudentProfile />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
        {
          path: 'coaches-List/coach-details',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <CoachDetails />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
        {
          path: 'content-oversight',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <CustomPosesTable />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
        // {
        //   path: 'subscription-panel',
        //   element: <CoachSubscription />
        // },
        {
          path: 'enrollment',
          element: <Enrollment />
        },
        {
          path: 'payment-logs',
          element: <PaymentLogs />
        },
        {
          path: 'coupons',
          element: <Coupons />
        },
        {
          path: 'system-monitoring',
          element: <SystemMonitoring />
        },
        {
          path: 'feature-announcement',
          element: <FeatureAnnouncement />
        },

        {
          path: 'myclasses',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <Student />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
        {
          path: 'summary',
          element: <SessionSummary />
        },
        {
          path: 'accuracy-breakdown',
          element: <BreakDown />
        },
        {
          path: 'progress-tracker',
          element: <ProgressTracker />
        },
        {
          path: 'student-support',
          element: <StudentSupport />
        },
        {
          path: 'view-student-pose-data',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <ViewStudentPoseData />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
        {
          path: 'dashboard',
          element: (
            // routeAccess({
            //   moduleid: 1,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <Dashboard />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
        {
          path: 'profile/editprofile',
          element: (
            //   // routeAccess({
            //   //   moduleid: 1,
            //   //   rolePermissions: rolePermissions
            //   // })?.hasAccess ? (
            <EditProfile />
          )
          //   // ) : (
          //   //   <MaintenanceError />
          //   // )
        },

        {
          path: 'profile/viewprofile',
          element: (
            //   // routeAccess({
            //   //   moduleid: 1,
            //   //   rolePermissions: rolePermissions
            //   // })?.hasAccess ? (
            <ViewProfile />
          )
          //   // ) : (
          //   //   <MaintenanceError />
          //   // )
        },
        {
          path: 'reports',
          element: (
            // routeAccess({
            //   moduleid: 10,
            //   rolePermissions: rolePermissions
            // })?.hasAccess ? (
            <ReportTab />
          )
          // ) : (
          //   <MaintenanceError />
          // )
        },
       
        {
          path: 'settings',
          children: [
            {
              path: 'admin',
              element: (
                // routeAccess({
                //   moduleid: 12,
                //   submoduleid: 3,
                //   rolePermissions: rolePermissions
                // })?.hasAccess ? (
                <Admin />
              )
              // ) : (
              //   <MaintenanceError />
              // )
            },
            {
              path: 'rolesandpermissions',
              element: (
                // routeAccess({
                //   moduleid: 12,
                //   submoduleid: 4,
                //   rolePermissions: rolePermissions
                // })?.hasAccess ? (
                <RolesAndPermission />
              )
              // ) : (
              //   <MaintenanceError />
              // )
            },
            {
              path: 'admin-details',
              element: (
                // routeAccess({
                //   moduleid: 12,
                //   submoduleid: 3,
                //   rolePermissions: rolePermissions
                // })?.hasAccess ? (
                <AdminView />
              )
              // ) : (
              //   <MaintenanceError />
              // )
            },
            {
              path: 'complainttype',
              element: (
                // routeAccess({
                //   moduleid: 12,
                //   submoduleid: 6,
                //   rolePermissions: rolePermissions
                // })?.hasAccess ? (
                <ComplaintType />
              )
              // ) : (
              //   <MaintenanceError />
              // )
            },
            {
              path: 'company',
              element: (
                // routeAccess({
                //   moduleid: 12,
                //   submoduleid: 7,
                //   rolePermissions: rolePermissions
                // })?.hasAccess ? (
                <Company />
              )
              // ) : (
              //   <MaintenanceError />
              // )
            },

            {
              path: 'companydetails',
              element: (
                // routeAccess({
                //   moduleid: 12,
                //   submoduleid: 7,
                //   rolePermissions: rolePermissions
                // })?.hasAccess ? (
                <ViewCompany />
              )
              // ) : (
              //   <MaintenanceError />
              // )
            },
            // {
            //   path: 'priority',
            //   element: <PriorityTable />
            // },
            // {
            //   path: 'roles',
            //   element: <RoleTable />
            // },

            {
              path: 'documents',
              element: (
                // routeAccess({
                //   moduleid: 12,
                //   submoduleid: 8,
                //   rolePermissions: rolePermissions
                // })?.hasAccess ? (
                <DocumentTab />
              )
              // ) : (
              //   <MaintenanceError />
              // )
            }
          ]
        },
        // MANAGER ROUTES
        {
          path: 'manager-courses',
          element: <ManagerCourses />
        },
        {
          path: 'staff-management',
          element: <StaffManagement />
        },
        {
          path: 'manager-student-reports',
          element: <ManagerStudentReports />
        },
        {
          path: 'manager-session-reports',
          element: <ManagerSessionReports />
        },
        {
          path: 'manager-support',
          element: <ManagerSupport />
        },
        // STAFF ROUTES
        {
          path: 'staff-dashboard',
          element: <StaffDashboard />
        },
        {
          path: 'staff-myclasses',
          element: <StaffMyClasses />
        },
        {
          path: 'staff-students',
          element: <StaffStudents />
        },
        {
          path: 'staff-progress-tracker',
          element: <StaffProgressTracker />
        },
        {
          path: 'staff-support',
          element: <StaffSupport />
        },
        {
          path: 'staff-summary',
          element: <StaffSummary />
        }
      ]
    },
    {
      path: '/',
      element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
      children: [
        {
          path: 'contact-us',
          element: <AppContactUS />
        }
      ]
    },
    {
      path: '/maintenance',
      element: <PagesLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        }
      ]
    }
  ]
};

export default MainRoutes;
